export enum StatusOptions{
    Enabled = 'Activo',
    Disabled = 'Desactivado'
}